import { type Theme } from '#app/theme/index.js';
import { css, styled } from 'styled-components';

// This should be the inverse of input's horizontal padding.
const negativeInputPadding = '-4px';

export const StyledTextFieldInputAddon = styled.div<{
  $appended: boolean;
  $color?: Extract<keyof Theme['colors'], 'brandBlack'>;
  $isDisabled: boolean;
}>`
  ${({ $appended, $color, theme }) => css`
    display: flex;
    color: ${theme.colors[$color ? $color : 'gray50']};

    margin-${$appended ? 'left' : 'right'}: ${negativeInputPadding} !important;
  `}
`;
